<div class="dialog-header">
  <h2 mat-dialog-title>Изъять квоту</h2>
  <button mat-icon-button (click)="close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="app-info">
    <p><strong>Компания:</strong> {{ data.assignment.application.companyName }}</p>
    <p><strong>{{ 'revokeQuotaDialog.meatType' | translate }}:</strong> {{ getMeatTypeName(data.assignment.application.meatType) }}</p>
    <p><strong>Распределенный объем:</strong> {{ data.assignment.allocatedVolume / 1000 }} т</p>
    <p><strong>Остаток:</strong> {{ data.assignment.remainderVolume / 1000 }} т</p>
  </div>

  <form class="form-content">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ПИН</mat-label>
      <input matInput [ngModel]="personIdnp" name="personIdnp"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'personIdnp')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['personIdnp']) {
      <div class="field-error">{{ fieldErrors()['personIdnp'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>ИНН организации</mat-label>
      <input matInput [ngModel]="organizationInn" name="organizationInn"
             inputmode="numeric" maxlength="14"
             (input)="onNumericInput($event, 'organizationInn')"
             (keydown)="onKeyDown($event)">
    </mat-form-field>
    @if (fieldErrors()['organizationInn']) {
      <div class="field-error">{{ fieldErrors()['organizationInn'] }}</div>
    }

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Причина изъятия</mat-label>
      <textarea matInput [(ngModel)]="reason" name="reason" rows="3" required></textarea>
      <mat-hint>Укажите причину изъятия квоты</mat-hint>
    </mat-form-field>
  </form>

  @if (errorMessage()) {
    <div class="error-message">{{ errorMessage() }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="close()">Отмена</button>
  <button mat-raised-button color="warn"
          (click)="submit()"
          [disabled]="!isFormValid() || loading()">
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      Подписать и изъять
    }
  </button>
</mat-dialog-actions>
